import React from "react";
import { Channel, Thread } from "stream-chat-react";
// Not actually used because of Window component on web, but needed for compilation
// so that we don't pull in react-native components
export const ChatThread = ({ thread, channel }) => (
  <Channel channel={channel} thread={thread}>
    <Thread thread={thread} />
  </Channel>
);
